import { cn } from '@/lib/utils';

interface TemplateListSkeletonProps {
  pulse?: boolean;
}

export const TemplateListSkeleton = ({
  pulse = true,
}: TemplateListSkeletonProps) => {
  return (
    <div className="relative flex w-full flex-col gap-3 overflow-hidden">
      <div
        className={cn(
          'h-4 w-32 rounded-md bg-gray-200 opacity-0',
          pulse && 'animate-pulse opacity-100',
        )}
      />
      <div
        className={cn(
          'flex h-fit w-full flex-col justify-start gap-2 rounded-lg border bg-gray-100 px-5 py-4',
          pulse && 'animate-pulse',
        )}>
        <div className="h-6 w-64 rounded-md bg-gray-200" />
        <div className="h-4 w-32 rounded-md bg-gray-200" />
      </div>
      <div
        className={cn(
          'flex h-fit w-full flex-col justify-start gap-2 rounded-lg border bg-gray-100 px-5 py-4',
          pulse && 'animate-pulse',
        )}>
        <div className="h-6 w-64 rounded-md bg-gray-200" />
        <div className="h-4 w-32 rounded-md bg-gray-200" />
      </div>
      <div
        className={cn(
          'flex h-fit w-full flex-col justify-start gap-2 rounded-lg border bg-gray-100 px-5 py-4',
          pulse && 'animate-pulse',
        )}>
        <div className="h-6 w-64 rounded-md bg-gray-200" />
        <div className="h-4 w-32 rounded-md bg-gray-200" />
      </div>
      <div
        className={cn(
          'flex h-fit w-full flex-col justify-start gap-2 rounded-lg border bg-gray-100 px-5 py-4',
          pulse && 'animate-pulse',
        )}>
        <div className="h-6 w-64 rounded-md bg-gray-200" />
        <div className="h-4 w-32 rounded-md bg-gray-200" />
      </div>
      <div className="absolute inset-0 bg-linear-to-b from-transparent to-white" />
    </div>
  );
};
